import React from 'react';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import Claim, {
  CLAIM_COLOR,
  CLAIM_SIZE,
} from '@bit/gerenciatd.unifiedcomponents.claim';
import './PromotionHired.scss';

export const COMPONENT_NAME = 'promotionhired';

const PromotionHired = ({
  className,
  promotionEndDate,
  textoPromo,
  isFlyout,
}) => {
  if (!promotionEndDate && !textoPromo) {
    return null;
  }

  return (
    <div className={`PromotionHired ${className} contratado`}>
      {promotionEndDate && textoPromo && (
        <div
          className={`PromotionHired__promo-area ${
            isFlyout ? 'without-padding' : 'with-padding'
          }`}
        >
          <div className="PromotionHired__promo-header">
            <Claim
              bgColor={CLAIM_COLOR.PURPLE}
              color={CLAIM_COLOR.WHITE}
              label={`TU PROMOCIÓN VENCE EL ${promotionEndDate}`}
              size={CLAIM_SIZE.SMALL}
            />
          </div>
          <div className="PromotionHired__promo-content">
            <TextInfo
              text={textoPromo}
              kind={KIND_TEXT.SPAN}
              align={ALIGN.LEFT}
              color={COLOR.GREY_6}
              size={SIZE.caption01}
              fontType={FONT_TYPE.REGULAR}
            />
          </div>
        </div>
      )}
    </div>
  );
};

PromotionHired.defaultProps = {
  showSections: true, // showsections
  isFlyout: false,
};

export default PromotionHired;
